export const getTokenFromUrl = (): string => {
  const searchParams = new URLSearchParams(document.location.search)
  return searchParams.get('token') ?? ''
}
